import React from 'react';
import { FormikProps } from 'formik';
import Banner from '@cpg-its/ads.containers.banner';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import {
    getMaritalStatusOptionsByCurrent,
    MaritalStatuses,
} from '../../../../global/constants/lists';
import { getFormattedDate } from '../../../../global/helpers/date-helpers';
import { FormField } from '../../../../global/components/form-element/form-field';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { RelationshipsProps } from '../../models/account-info-epi-props';

interface MaritalFieldProps {
    formProps: FormikProps<any>;
    maritalStatusLabel: string;
    dateOfMarriageLabel: string;
    endOfMarriageLabel: string;
    tooltipMessage: string;
    maritalStatus: string;
    effectiveDate: string;
    admin: boolean;
    showConfirmation: boolean;
    onStatusChange: () => void;
    widowedPreliminaryDateDeathLabel: string;
    widowedDateDeathLabel: string;
    legallySeparatedLabel: string;
    legalSeparationDate: string;
    relationshipsProps: RelationshipsProps;
}
export function MaritalFields(props: MaritalFieldProps) {
    const {
        formProps,
        maritalStatusLabel,
        dateOfMarriageLabel,
        endOfMarriageLabel,
        tooltipMessage,
        maritalStatus,
        effectiveDate,
        admin,
        onStatusChange,
        showConfirmation,
        widowedPreliminaryDateDeathLabel,
        widowedDateDeathLabel,
        legallySeparatedLabel,
        legalSeparationDate = null,
        relationshipsProps,
    } = props;

    const renderMaritalStatusOptions = () => {
        // Only show the options when not in the confirmation.
        if (showConfirmation) {
            return null;
        }

        return (
            <>
                <FormField
                    name="marital_status"
                    label={maritalStatusLabel}
                    component="radioGroup"
                    options={getMaritalStatusOptionsByCurrent(maritalStatus, !!legalSeparationDate)}
                    touched={formProps.touched}
                    errors={formProps.errors}
                    onChange={onStatusChange}
                    required
                />
            </>
        );
    };

    function GetEndOfMarriageLabel(): string {

        if (maritalStatus !== MaritalStatuses.Widowed && formProps.values.marital_status === MaritalStatuses.Widowed) {
            return widowedPreliminaryDateDeathLabel;
        }

        if (maritalStatus === MaritalStatuses.Widowed && formProps.values.marital_status === MaritalStatuses.Widowed) {
            return widowedDateDeathLabel;
        }

        if (maritalStatus !== MaritalStatuses.Widowed && formProps.values.marital_status === MaritalStatuses.Married && !!legalSeparationDate) {
            return legallySeparatedLabel;
        }

        return endOfMarriageLabel;
    }

    const renderDateOfMarriage = () => {
        if (formProps.values.marital_status === MaritalStatuses.Married) {

            // don't show date of marriage if going from single to married as admin
            if (maritalStatus !== MaritalStatuses.Married && admin) return null;

            if (legalSeparationDate) {
                return (
                    <>
                        <FormField
                            name='marital_status_effective_date'
                            label={dateOfMarriageLabel}
                            component='datePicker'
                            touched={formProps.touched}
                            errors={formProps.errors}
                            required
                            autoWidth
                            tooltip={{
                                title: tooltipMessage,
                            }}
                        />
                        <div className="form-item">
                            <p><strong>{GetEndOfMarriageLabel()}</strong></p>
                            <p>{getFormattedDate(legalSeparationDate)}</p>
                        </div>
                        <ContentSpacer>
                            <Banner banner={{
                                type: 'info',
                                label: <p className='h5-styled'>{relationshipsProps?.legalSeparationDateBannerTitle} </p>,
                                description: <WysiwygWithReactLink content={relationshipsProps?.legalSeparationDateBannerDescription} />,
                            }} />
				        </ContentSpacer>
                    </>
                );
            }

            return (
                <>
                    <FormField
                        name='marital_status_effective_date'
                        label={dateOfMarriageLabel}
                        component='datePicker'
                        touched={formProps.touched}
                        errors={formProps.errors}
                        required
                        autoWidth
                        tooltip={{
                            title: tooltipMessage,
                        }}
                    />

                </>

            );
        }

        if (
            formProps.values.marital_status === MaritalStatuses.Divorced ||
            formProps.values.marital_status === MaritalStatuses.Widowed ||
            formProps.values.marital_status === MaritalStatuses.LegallySeparated
        ) {
            return (
                <>
                    <div className="form-item">
                        <p><strong>{dateOfMarriageLabel}</strong></p>
                        <p>{getFormattedDate(effectiveDate)}</p>
                    </div>
                    <FormField
                        name="marriage_end_date"
                        label={GetEndOfMarriageLabel()}
                        component="datePicker"
                        touched={formProps.touched}
                        errors={formProps.errors}
                        required
                        autoWidth
                    />
                </>
            );
        }

        return null;
    };

    return (
        <DividerSection
            removeDivider={
                formProps.values.marital_status !== MaritalStatuses.Married
            }
        >
            <FormGroup>
                {renderMaritalStatusOptions()}
                {renderDateOfMarriage()}
            </FormGroup>
        </DividerSection>
    );
}
